<div id="mynetwork" #networkContainer fxFill class="a"></div>
